module.exports = __webpack_public_path__ + "img/case_banner.a6b0e91e.png";